import React from 'react';

var NavRow = function (_a) {
    var children = _a.children, isVersion2 = _a.isVersion2;
    return React.createElement("div", { className: "mobile-navigation-row ".concat(isVersion2 ? 'version-2' : '') }, children);
};

export { NavRow };
